import { ComponentStyles } from "types/common";

export const styles: ComponentStyles = {
  customIcons: {
    // width: "90%",
    // height: "90%",
    objectFit: "contain",
  },
};
